export default {
  SettingBaseDataRegion: {
    newProvincial: 'Add',
    msgWarning: 'The returned data is empty, please contact the administrator',

    table: {
      code: 'Region Code',
      name: 'Region Name',
      abbreviation: 'Abbreviation',
      subordinateArea: 'Create Subordinate Region',
    },

    addAndEdit: {
      addTitle: 'Create administrative region definition',
      editTitle: 'Edit administrative region definition',
      code: 'Area Code',
      name: 'Area Name',
      abbreviation: 'Abbreviation',
      superiorArea: 'Parent Area',
      countryCodeText: 'Please enter country code',
      countryNameText: 'Please enter country name',

    }
  }
};
